import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import logoBanner from "../../assets/logo/Logo-BlueZone.png";
import check from "../../assets/icons/mdi_check.svg";
import listForm from "../../assets/icons/form-icon.svg";
import telesale from "../../assets/icons/Telesale-icon.svg";
import finishForm from "../../assets/icons/finish-form-icon.svg";
import App from "../../assets/icons/APp-icon.svg";
import elipsePurple from "../../assets/icons/ellipse-purple.svg";
import elipseGreen from "../../assets/icons/ellipse-green.svg";
import elipsePink from "../../assets/icons/ellipse-pink.svg";
import elipseBlue from "../../assets/icons/ellipse-blue.svg";
import polygon1 from "../../assets/polygons/Polygon 1 (Stroke).svg";
import polygon2 from "../../assets/polygons/Polygon 2 (Stroke).svg";
import polygon3 from "../../assets/polygons/Polygon 3 (Stroke).svg";
import polygon4 from "../../assets/polygons/Polygon 4 (Stroke).svg";
import polygon5 from "../../assets/polygons/Polygon 5 (Stroke).svg";
import polygon6 from "../../assets/polygons/Polygon 6 (Stroke).svg";
import polygon7 from "../../assets/polygons/Polygon 7 (Stroke).svg";
import polygon8 from "../../assets/polygons/Polygon 8 (Stroke).svg";
import aboutUs from "../../assets/images/Rectangle 30.png";
import moneyOnline from "../../assets/icons/Money-Online.svg";
import creditCard from "../../assets/icons/fa_credit-card.svg";
import listCheck from "../../assets/icons/ant-design_file-protect-outlined.svg";
import smile from "../../assets/icons/Smile.svg";
import info from "../../assets/icons/i.svg";
import vinaphone from "../../assets/logo-partner/vinaphone.png";
import trueMoney from "../../assets/logo-partner/true-money.png";
import feCredit from "../../assets/logo-partner/fe-credit.png";
import vib from "../../assets/logo-partner/vib-blue.png";
import lotte from "../../assets/logo-partner/lotte.png";
import tpbank from "../../assets/logo-partner/tpbank.png";
import bidv from "../../assets/logo-partner/bidv.png";
import f88 from "../../assets/logo-partner/f88.jpg";
import mobifone from "../../assets/logo-partner/mobifone.png";
import techcombank from "../../assets/logo-partner/techcombank.png";
import tpfico from "../../assets/logo-partner/tpfico.png";
import viettel from "../../assets/logo-partner/viettel.png";
import phoneWoman from "../../assets/images/mobile 1.png";
import ellipse from "../../assets/polygons/EllipseWhyUse.svg";
import appWhite from "../../assets/icons/APp-icon-white.svg";
import vector from "../../assets/icons/Vector.svg";
import donghoWhite from "../../assets/icons/fastdongho-white.svg";
import moneyWhite from "../../assets/icons/money-white.svg";
import RegisterCardSection from "./RegisterCardSection";

let currentOpen = null;
function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (currentOpen && currentOpen !== setOpen) {
      currentOpen(false);
    }
    const newState = !open;
    setOpen(newState);
    currentOpen = newState ? setOpen : null;
  };

  return (
    <div className={`faq-item${open ? " open" : ""}`}>
      <div className="faq-question" onClick={handleClick}>
        {question}
        <span className={`faq-arrow${open ? " open" : ""}`}>
          <svg
            width="25"
            height="25"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              transform: open ? "rotate(360deg)" : "rotate(0deg)",
            }}
          >
            <path
              d="M6 8L10 12L14 8"
              stroke="#222"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
}

const MoThe = () => {
  const registerRef = useRef(null);

  const handleScroll = () => {
    registerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="open-card">
      <section className="mothe-section">
        <div className="mothe-content container">
          <div className="row">
            <div className="content-right">
              <div className="col-lg-6">
                <div className="mothe-subtitle">
                  Giải pháp tài chính ưu việt
                </div>
                <h1 className="mothe-title">
                  <span className="text-lean">MỞ THẺ SIÊU NHANH</span>
                  <br />
                  <span className="text-normal">giao dịch thả phanh</span>
                </h1>
                <div className="mothe-features row">
                  <div className="col-md-6">
                    <div className="mothe-feature-item d-flex align-items-center">
                      <div className="check-icon">
                        <img src={check} alt="check" className="check" />
                      </div>
                      <div>Tinh gọn giải pháp</div>
                    </div>
                    <div className="mothe-feature-item d-flex align-items-center">
                      <div className="check-icon">
                        <img src={check} alt="check" className="check" />
                      </div>
                      <div>Xây điểm tín dụng</div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="mothe-feature-item d-flex align-items-center">
                      <div className="check-icon">
                        <img src={check} alt="check" className="check" />
                      </div>
                      <div>Sẵn sàng hỗ trợ</div>
                    </div>
                    <div className="mothe-feature-item d-flex align-items-center">
                      <div className="check-icon">
                        <img src={check} alt="check" className="check" />
                      </div>
                      <div>Hoàn tiền giao dịch</div>
                    </div>
                  </div>
                </div>
                <div className="button-mothe">
                  <button className="btn-mothe" onClick={handleScroll}>
                    Mở thẻ tín dụng online
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div ref={registerRef}>
        <RegisterCardSection />
      </div>

      <section className="why-mothe-section">
        <div className="container">
          <h2 className="why-mothe-title">
            Tại sao bạn nên chọn sử dụng thẻ tín dụng
          </h2>
          <div className="row">
            <div className="col-md-7 why-use-left">
              <div className="why-use-content">
                <div className="ellipse-icon">
                  <img
                    src={ellipse}
                    alt="ellipse"
                    className="why-use-ellipse-1"
                  />
                  <img src={appWhite} alt="app" className="app-white" />
                </div>
                <div className="content-text">
                  <p className="why-use-title">
                    <span>ĐƯỢC HOÀN TIỀN TRÊN CÁC HÓA ĐƠN THANH TOÁN</span>
                  </p>
                  <div className="why-use-divider"></div>
                  <p className="why-use-text">
                    Thẻ tín dụng có tính năng hoàn tiền khi bạn chi tiêu. Số
                    phần trăm tiền hoàn lại sẽ phụ thuộc vào từng loại thẻ tín
                    dụng, mỗi một thẻ tín dụng sẽ có một mức hoàn tiền khác
                    nhau.
                  </p>
                </div>
              </div>

              <div className="why-use-content">
                <div className="ellipse-icon">
                  <img
                    src={ellipse}
                    alt="ellipse"
                    className="why-use-ellipse-2"
                  />
                  <img src={vector} alt="app" className="vector-white" />
                </div>
                <div className="content-text">
                  <p className="why-use-title">
                    <span>ĐƯỢC TÍCH ĐIỂM THƯỞNG SAU MỖI GIAO DỊCH</span>
                  </p>
                  <div className="why-use-divider"></div>
                  <p className="why-use-text">
                    Sau khi thực hiện một giao dịch, tùy vào thẻ tín dụng của
                    bạn là loại gì mà bạn sẽ được cộng điểm thưởng cho mỗi giao
                    dịch. Bạn có thể sử dụng điểm thưởng này để chi tiêu các hóa
                    đơn siêu thị hoặc chi tiêu cho các nhu cầu mua sắm khác.
                  </p>
                </div>
              </div>

              <div className="why-use-content">
                <div className="ellipse-icon">
                  <img
                    src={ellipse}
                    alt="ellipse"
                    className="why-use-ellipse-3"
                  />
                  <img src={donghoWhite} alt="app" className="dong-ho-white" />
                </div>
                <div className="content-text">
                  <p className="why-use-title">
                    <span>100% ONLINE TIẾT KIỆM THỜI GIAN - CÔNG SỨC</span>
                  </p>
                  <div className="why-use-divider"></div>
                  <p className="why-use-text">
                    Mở thẻ tín dụng online bạn có thể sở hữu chiếc thẻ tín dụng
                    của mình mà không cần phải ra ngân hàng để làm các thủ tục
                    xác minh, hồ sơ giấy tờ và đợi xét duyệt mở thẻ theo phương
                    pháp truyền thống.
                  </p>
                </div>
              </div>

              <div className="why-use-content">
                <div className="ellipse-icon">
                  <img
                    src={ellipse}
                    alt="ellipse"
                    className="why-use-ellipse-4"
                  />
                  <img src={moneyWhite} alt="app" className="money-white" />
                </div>
                <div className="content-text">
                  <p className="why-use-title">
                    <span>CỨU TINH KHI BẠN HẾT TIỀN</span>
                  </p>
                  <div className="why-use-divider"></div>
                  <p className="why-use-text">
                    Khi bạn hết tiền thẻ tín dụng sẽ là nguồn tiền giúp bạn vượt
                    qua giai đoạn cháy ví
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-5 why-use-right">
              <img src={phoneWoman} alt="phone woman" className="phone-woman" />
            </div>
          </div>
          <div className="why-mothe-button">
            <button className="btn-mothe" onClick={handleScroll}>
              Mở thẻ tín dụng online
            </button>
          </div>
        </div>
      </section>

      <section className="works-section-vayonline">
        <h2 className="works-title">Quy trình mở thẻ đơn giản</h2>
        <p className="works-description">
          Thủ tục nhanh gọn, chỉ với 4 bước đơn giản để nhận thẻ tín dụng online
          sau 15 phút
        </p>
        <div className="works-content">
          <div className="work-one">
            <img src={listForm} alt="listForm" className="listForm" />
            <img src={polygon1} alt="polygon1" className="polygon-1" />
            <div className="line-1"></div>
            <div className="elipse-purple">
              <img src={elipsePurple} alt="" />
            </div>
            <span className="number-one">1</span>
            <span className="text-work-one">
              Điền thông tin
              <br /> đăng ký vay
            </span>
          </div>

          <div className="work-two">
            <img src={telesale} alt="telesale" className="telesale" />
            <img src={polygon2} alt="polygon2" className="polygon-2" />
            <div className="line-2"></div>
            <div className="elipse-green">
              <img src={elipseGreen} alt="" />
            </div>
            <span className="number-two">2</span>
            <span className="text-work-two">
              Nhân viên chăm sóc khách hàng sẽ liên lạc với bạn để tư vấn &
              hướng dẫn chuẩn bị các thủ tục đơn giản, nhanh gọn
            </span>
          </div>

          <div className="work-three">
            <img src={finishForm} alt="finishForm" className="finishForm" />
            <img src={polygon3} alt="polygon3" className="polygon-3" />
            <div className="line-3"></div>
            <div className="elipse-pink">
              <img src={elipsePink} alt="" />
            </div>
            <span className="number-three">3</span>
            <span className="text-work-three">
              Bạn nhận luôn kết quả phê duyệt hoặc cập nhật thông qua Zalo OA
              hoặc website của Blue-zone để hoàn tất thủ tục & ký hồ sơ chỉ
              trong vòng 15 phút
            </span>
          </div>

          <div className="work-four">
            <img src={App} alt="APp" className="app" />
            <img src={polygon4} alt="polygon4" className="polygon-4" />
            <div className="line-4"></div>
            <div className="elipse-blue">
              <img src={elipseBlue} alt="" />
            </div>
            <span className="number-four">4</span>
            <span className="text-work-four">
              Blue-zone thẩm định, phê duyệt hồ sơ và cấp thẻ cho khách hàng sử
              dụng thẻ
            </span>
          </div>

          <img src={polygon5} alt="polygon5" className="polygon-5" />
          <img src={polygon6} alt="polygon6" className="polygon-6" />
          <img src={polygon7} alt="polygon7" className="polygon-7" />
          <img src={polygon8} alt="polygon8" className="polygon-8" />
          <div className="line"></div>
        </div>
        <div className="d-flex justify-content-center">
          <div
            className="info-work d-flex align-items-center rounded-3 py-3 px-3 gap-3 mb-0 w-100"
            role="alert"
          >
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-50 dots-white">
              <img src={info} alt="info" />
            </div>
            <div className="d-flex flex-column">
              <div className="fw-semibold">Lưu ý quan trọng</div>
              <div className="small mb-0">
                Quá trình giải ngân có thể nhanh hơn tùy thuộc vào tình trạng hồ
                sơ của bạn. Nhân viên tư vấn sẽ hỗ trợ bạn trong suốt quá trình.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <img className="about-image" src={aboutUs} alt="About Blue-zone" />
        <div className="about-content">
          <h2 className="about-title">Về chúng tôi</h2>
          <div className="about-subtitle mb-2">
            Trao cho bạn một tương lai tài chính vững vàng, ngay KHI BẠN CẦN
          </div>
          <p className="about-description">
            Blue-zone ra đời vào năm 2025 với vai trò là một website cung cấp
            thông tin về các sản phẩm tài chính đầy đủ và cập nhật nhất đến cho
            Khách hàng từ các Ngân hàng và Tổ chức tài chính uy tín tại Việt
            Nam.
            <br />
            <br />
            Blue-zone thực hiện lựa chọn và giới thiệu các sản phẩm tài chính
            phù hợp dựa trên các thông tin được Khách hàng cung cấp,{" "}
            <strong>
              đảm bảo tỷ lệ phê duyệt cao với thủ tục đơn giản, đi kèm nhiều ưu
              đãi độc quyền
            </strong>{" "}
            trên nền tảng công nghệ tiên tiến và thân thiện với người dùng.
          </p>
        </div>
      </section>

      <section className="about-stats">
        <div className="container">
          <div className="stats-container row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 d-flex justify-content-center">
            <div className="stats-item">
              <img src={moneyOnline} alt="Khách hàng" className="stats-icon" />
              <div className="stats-number">+10.000</div>
              <div className="stats-label">Khách hàng vay tiền online</div>
            </div>
            <div className="stats-item">
              <img src={creditCard} alt="Đối tác" className="stats-icon" />
              <div className="stats-number">+3.500</div>
              <div className="stats-label">
                Khách hàng mở thẻ <br /> tín dụng
              </div>
            </div>
            <div className="stats-item">
              <img src={listCheck} alt="Sản phẩm" className="stats-icon" />
              <div className="stats-number">+1.000</div>
              <div className="stats-label">
                Khách hàng tiếp cận <br /> bảo hiểm
              </div>
            </div>
            <div className="stats-item">
              <img src={smile} alt="Kinh nghiệm" className="stats-icon" />
              <div className="stats-number">+10.500</div>
              <div className="stats-label">
                Khách hàng sử dụng lại <br /> dịch vụ
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="partners-section">
        <h2 className="partners-title">Đồng hành các đối tác uy tín</h2>
        <p className="partners-description">
          Bluezone là đối tác chiến lược của nhiều Ngân hàng và Tổ chức tài
          chính lớn, uy tín khắp Việt Nam
        </p>
        <div className="partners-slider">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={40}
            slidesPerView={4}
            navigation
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            breakpoints={{
              375: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            // nextButton={<div className="swiper-button-next" />}
            // prevButton={<div className="swiper-button-prev" />}
          >
            <SwiperSlide>
              <div className="image-logo">
                <img src={vinaphone} alt="vinaphone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={trueMoney} alt="trueMoney" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={feCredit} alt="vinaphone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={lotte} alt="lotte" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img
                  src={techcombank}
                  alt="techcombank"
                  className="logo-partner"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={tpbank} alt="tpbank" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={vib} alt="vib" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={bidv} alt="bidv" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={f88} alt="f88" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={mobifone} alt="mobifone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={tpfico} alt="tpfico" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={viettel} alt="viettel" className="logo-partner" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>

      <section className="banner-mothe-section">
        <div className="banner-mothe-content">
          <div className="banner-mothe-logo">
            <img src={logoBanner} alt="banner-logo" />
          </div>
          <h1 className="banner-mothe-title">
            Nhận ngay Thẻ Tín dụng phù hợp với nhu cầu của bạn
          </h1>
          <div className="banner-mothe-description">
            <span>
              Hãy để lại thông tin của mình chính xác đúng và đủ theo yêu cầu,
              nhân viên tư vấn Blue-zone ngay lập tức sẽ liên hệ và kết nối bạn
              đến với sản phẩm phù hợp nhất
            </span>
          </div>
          <div className="button-banner-mothe">
            <a href="/lien-he" className="btn-link">
              <button className="button-ban green">
                Liên hệ với chúng tôi
              </button>
            </a>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <h2 className="testimonial-title">
          Khách hàng trên 63 tỉnh thành
          <br />
          hài lòng về dịch vụ
        </h2>
        <div className="testimonial-rating">
          <span className="stars">★★★★★</span>
          <span className="score">4.9/5 (437 bình chọn)</span>
        </div>
        <div className="testimonial-cards">
          <div className="testimonial-card">
            <div className="testimonial-stars">★★★★★</div>
            <div className="testimonial-text">
              Tôi cần vốn gấp để nhập hàng kinh doanh, bạn bè tôi biết thì giới
              thiệu vay ở Blue-zone. Lãi suất thì thua rẻ bên nào cũng như nhau,
              cạnh tranh nhau cả, tôi chỉ cần thủ tục nhanh gọn mà minh bạch nên
              chọn Blue-zone và ai cũng gợi ý ở đây. Quy trình đăng ký online
              nhanh chóng, chỉ sau 15 phút là nhân viên liên hệ tư vấn nhiệt
              tình, niềm nở lắm. Tôi còn không mất phí khi tất toán sớm tại
              Blue-zone. Dịch vụ chuyên nghiệp, minh bạch, hỗ trợ tận tình. Tôi
              rất hài lòng!
            </div>
            <div className="testimonial-user">
              <strong>Chị Nguyễn Hoàng Linh</strong>
              <br />
              30 tuổi - Hà Nội
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-stars">★★★★★</div>
            <div className="testimonial-text">
              Tôi bị mất việc nên cần tiền gấp để trang trải sinh hoạt. Cái tôi
              cần nhất là có thể đăng ký vay online đơn giản, tư vấn nhiệt tình.
              Tôi giãn ngân qua Blue-zone nên mọi thủ tục đều được sớm mà tôi
              không bị tính phí. Đánh giá cho dịch vụ ở Blue-zone vì minh bạch
              và tin cậy!
            </div>
            <div className="testimonial-user">
              <strong>Anh Hoàng Bình Minh</strong>
              <br />
              22 tuổi - Cần Thơ
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-stars">★★★★★</div>
            <div className="testimonial-text">
              Gia đình tôi cần tiền gấp để chi trả viện phí. Tôi chọn Blue-zone
              vì quy trình vay nhanh chóng, dễ dàng khi gửi tài sản tại tổ chức
              tài chính khác (tôi ưu tiên lựa chọn VPbank vì điểm giao dịch ngay
              gần nhà tôi). Đặc biệt, không mất phí trả nợ trước hạn, rất phù
              hợp với người cần vay ngắn hạn như tôi. Dịch vụ hỗ trợ tận tâm,
              thủ tục minh bạch. Tôi thực sự yên tâm và hài lòng
            </div>
            <div className="testimonial-user">
              <strong>Anh Đỗ Minh Lê</strong>
              <br />
              40 tuổi - Đà Nẵng
            </div>
          </div>
        </div>
      </section>

      <section className="faq-section">
        <h2 className="faq-title">Câu hỏi thường gặp về khoản vay Online</h2>
        <div className="faq-list">
          <FAQItem
            question="Làm thế nào để lựa chọn được nền tảng vay online uy tín và an toàn?"
            answer={
              <>
                <span className="text-faq">
                  Để có thể tìm và chọn được một nền tảng vay tiền online uy tín
                  và an toàn bạn cần chú ý một số điều dưới đây:
                </span>
                <span className="text-faq-small">
                  Nghiên cứu và đánh giá: Tìm hiểu về các nền tảng vay tiền
                  online phổ biến trên thị trường. Đọc đánh giá từ người dùng
                  khác và tìm hiểu về danh tiếng của công ty.
                </span>
                <span className="text-faq-small">
                  Kiểm tra thông tin chính thức: Truy cập trang web chính thức
                  của bên cung cấp khoản vay và kiểm tra thông tin về công ty.
                  Xem xét địa chỉ liên hệ, chính sách bảo mật, điều khoản và
                  điều kiện sử dụng dịch vụ.
                </span>
                <span className="text-faq-small">
                  Xác minh đăng ký và giấy phép hoạt động. Đảm bảo rằng nền tảng
                  vay có giấy phép hoạt động hợp pháp từ các cơ quan chính phủ
                  có thẩm quyền. Thông tin này thường được hiển thị trên trang
                  web.
                </span>
                <span className="text-faq-small">
                  Kiểm tra và đánh giá từ người dùng: Tìm hiểu về các đánh giá,
                  phản hồi và kinh nghiệm từ người dùng trước đó, Thông tin này
                  có thể giúp bạn đánh giá tính đáng tin cậy và chất lượng của
                  dịch vụ.
                </span>
                <span className="text-faq-small">
                  Chuẩn bị danh sách câu hỏi: Chuẩn bị một danh sách câu hỏi
                  liên quan đến các chi tiết cụ thể về dịch vụ vay, bao gồm lãi
                  suất, phí, thời gian trả nợ, chính sách hoàn trả, và các điều
                  khoản quan trọng khác.
                </span>
                <span className="text-faq-small">
                  Liên hệ và yêu cầu thông tin: Liên hệ với nền tảng vay thông
                  qua các kênh hỗ trợ khách hàng có sẵn. Đặt các câu hỏi từ danh
                  sách bạn đã chuẩn bị và yêu cầu thông tin cụ thể để làm rõ các
                  điều khoản và điều kiện.
                </span>
                <span className="text-faq-small">
                  So sánh lãi suất và phí: So sánh lãi suất và phí của nền tảng
                  với các dịch vụ vay khác. Đảm bảo rằng các chi phí liên quan
                  đã được nêu rõ và dễ hiểu.
                </span>
                <span className="text-faq-small">
                  Phản ánh với người thân và bạn bè: Hỏi ý kiến của người thân
                  và bạn bè về nền tảng vay mà bạn quan tâm. Đôi khi họ có thể
                  cung cấp những thông tin hoặc gợi ý quý báu.
                </span>
                <span className="text-faq-small">
                  Kiểm tra chứng chỉ bảo mật: Trước khi cung cấp thông tin cá
                  nhân, kiểm tra xem trang web có chứng chỉ bảo mật SSL (Secure
                  Socket Layer) hay không. Biểu tượng khóa và địa chỉ URL bắt
                  đầu bằng https:// là dấu hiệu của trang web an toàn.
                </span>
                <span className="text-faq-small">
                  Khảo sát cẩn thận trước khi đồng ý: Trước khi đồng ý vay tiền,
                  đảm bảo rằng bạn đã đọc kỹ và hiểu rõ tất cả các điều khoản và
                  điều kiện của khoản vay. Nếu có điều gì đó không rõ ràng, hay
                  yêu cầu giải đáp thêm trước khi tiến hành.
                </span>
                <span className="text-faq">
                  <strong className="text-bold">Tóm lại,</strong> việc tìm và
                  chọn một nền tảng vay tiền online uy tín và an toàn đòi hỏi sự
                  cẩn thận và tìm hiểu kỹ lưỡng. Đừng bao giờ đồng ý vay tiền
                  nếu bạn cảm thấy không chắc chắn hoặc có bất kỳ nghi ngờ nào
                  về tính đáng tin cậy của bên cung cấp khoản vay online.
                </span>
              </>
            }
          />
          <FAQItem
            question="Vay tiền online cần những điều kiện gì?"
            answer={
              <>
                <span className="text-faq">
                  Để đủ điều kiện đăng ký các sản phẩm tài chính từ mạng lưới
                  đối tác của Blue-zone, bạn cần chú ý đạt được các điều kiện
                  sau:
                </span>
                <span className="text-faq-small">
                  Bạn cần là công dân Việt Nam, có CMND/CCCD còn hiệu lực
                </span>
                <span className="text-faq-small">
                  Sử dụng số điện thoại là thuê bao chính chủ để đăng ký
                </span>
                <span className="text-faq">
                  Sau đó Blue-zone sẽ dựa vào các thông tin khác mà bạn cung cấp
                  để đề xuất đến bạn sản phẩm phù hợp với khả năng được phê
                  duyệt cao nhất.
                </span>
              </>
            }
          />
          <FAQItem
            question="Cách xác minh danh tính và thông tin cá nhân khi vay tiền online?"
            answer={
              <>
                <span className="text-faq">
                  Để giúp Blue-zone xác minh chính xác danh tính của bạn giúp
                  quá trình phê duyệt được diễn ra dễ dàng và nhanh chóng, bạn
                  cần đăng ký bằng số điện thoại chính chủ đang sở hữu và thực
                  hiện xác thực theo mã OTP 6 số mà Blue-zone gửi về tin nhắn
                  Zalo hoặc tin nhắn điện thoại cho bạn, sau đó khai báo các
                  thông tin đi kèm một cách chính xác.
                </span>
              </>
            }
          />
          <FAQItem
            question="Blue-zone cung cấp khoản vay online có hạn mức tối đa là bao nhiêu?"
            answer={
              <>
                <span className="text-faq">
                  Mạng lưới các đối tác tài chính và sản phẩm Vay online của
                  Blue-zone rất đa dạng. Blue-zone có thể đề xuất và giới thiệu
                  bạn đến các khoản vay nhỏ từ 5.000.000 đồng cho đến khoản vay
                  tín chấp tới 300.000.000 đồng tùy thuộc vào nhu cầu hiện tại
                  của bạn.
                </span>
              </>
            }
          />
        </div>
      </section>
    </div>
  );
};

export default MoThe;
